import {alias, createModelSchema} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";

export class SkyCommonConfig extends BaseObject {

    constructor() {

        super();

        this._key = null;
        this._name = null;

        this._ab_test = 0;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get ab_test() {
        return this._ab_test;
    }

    set ab_test(value) {
        this._ab_test = value;
    }

    valid() {

        if (!Number.isInteger(this.ab_test) || this.ab_test < 0 || this.ab_test > 1) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SkyCommonConfig());
        } else if (target instanceof SkyCommonConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SkyCommonConfig, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _ab_test: alias("ab_test", Schema.primitive()),
});